/**
 * Web Bottom Navigation
 * Bottom tab bar for web/PWA - Matches mobile design
 */

import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Platform } from 'react-native';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from './Icon.web';

const WebBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { name: 'Quotes', path: '/home', icon: 'swap-vertical-outline', activeIcon: 'swap-vertical' },
    { name: 'Charts', path: '/charts', icon: 'bar-chart-outline', activeIcon: 'bar-chart' },
    { name: 'Trades', path: '/trades', icon: 'git-network-outline', activeIcon: 'git-network' },
    { name: 'History', path: '/history', icon: 'reload-circle-outline', activeIcon: 'reload-circle' },
    { name: 'Settings', path: '/settings', icon: 'settings-outline', activeIcon: 'settings' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <View style={styles.container}>
      <View style={styles.innerContainer}>
        {tabs.map((tab) => {
          const active = isActive(tab.path);
          return (
            <TouchableOpacity
              key={tab.path}
              style={styles.tab}
              onPress={() => navigate(tab.path)}
              activeOpacity={0.7}
            >
              <View style={[styles.iconContainer, active && styles.activeIconContainer]}>
                <Icon
                  name={active ? tab.activeIcon : tab.icon}
                  size={26}
                  color={active ? '#00f5a0' : '#6B7280'}
                />
              </View>
              <Text style={[styles.label, active && styles.activeLabel]}>
                {tab.name}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#0B1121',
    borderTopWidth: 1,
    borderTopColor: 'rgba(255, 255, 255, 0.08)',
    paddingBottom: Platform.OS === 'web' ? 0 : 8,
    ...(Platform.OS === 'web' && {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.3)',
    }),
  },
  innerContainer: {
    flexDirection: 'row',
    height: 70,
    paddingHorizontal: 8,
    paddingTop: 8,
    paddingBottom: 8,
  },
  tab: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 4,
  },
  iconContainer: {
    width: 40,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 12,
    marginBottom: 2,
  },
  activeIconContainer: {
    backgroundColor: 'rgba(0, 245, 160, 0.12)',
  },
  label: {
    fontSize: 11,
    marginTop: 2,
    color: '#6B7280',
    fontWeight: '500',
    letterSpacing: 0.2,
  },
  activeLabel: {
    color: '#00f5a0',
    fontWeight: '600',
  },
});

export default WebBottomNav;
